import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'

export const getColumns = () => [
  {
    title: 'Marca',
    field: 'globalId',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'AD',
    field: 'adAccount',
    align: 'left',
    type: 'boolean',
    width: '80px',
    disableSorting: true,
    render: row => (row.adAccount ? 'Yes' : 'No')
  },
  {
    title: 'LDAP',
    field: 'ldapAccount',
    align: 'left',
    type: 'boolean',
    width: '80px',
    disableSorting: true,
    render: row => (row.ldapAccount ? 'Yes' : 'No')
  },
  {
    title: 'Google',
    field: 'googleAccount',
    align: 'left',
    type: 'boolean',
    width: '80px',
    disableSorting: true,
    render: row => (row.googleAccount ? 'Yes' : 'No')
  },
  {
    field: 'startDate',
    title: 'Valid',
    align: 'left',
    type: 'date',
    width: '150px',
    disableSorting: true,
    collapsible: true,
    render: row => (
      <div>
        <div>START: {row.startDate}</div>
        <div>END: {row.endDate}</div>
      </div>
    )
  },
  { field: 'jobTitle', title: 'Position', align: 'left', type: 'string', collapsible: true },
  {
    field: 'personName',
    title: 'Name',
    align: 'left',
    type: 'string',
    collaapsible: true,
    disableSorting: true,
    // Using a div to ensure long emails break correctly in the table cell
    render: row => (
      <div style={{ wordBreak: 'break-all' }}>
        {row.person?.firstName} {row.person?.lastName}
      </div>
    )
  },
  {
    field: 'manager',
    title: 'Manager',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    render: row => (row.manager ? `${row.manager.firstName} ${row.manager.lastName}` : '')
  },
  {
    field: 'externalPartnerType',
    title: 'Type',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '100px',
    render: row => row.externalPartnerType?.name
  },
  {
    field: 'status',
    title: 'Status',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '100px',
    render: row => row.status?.name
  }
]

const hasAccountsOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
]

export const getFilters = (
  externalPartnerTypeOptions: AutocompleteOption[],
  statusOptions: AutocompleteOption[],
  managersOptions: AutocompleteOption[]
) => {
  return [
    {
      name: 'externalPartnerType.id',
      value: '',
      filter: (
        <Autocomplete variant="outlined" label="Type" options={externalPartnerTypeOptions || []} />
      ),
      type: 'autocomplete',
      label: 'Type'
    },
    {
      name: 'status.id',
      value: undefined,
      filter: (
        <Autocomplete variant="outlined" label="Status" options={statusOptions || []} multiple />
      ),
      type: 'autocomplete',
      label: 'Status'
    },
    {
      name: 'manager.id',
      value: '',
      filter: <Autocomplete variant="outlined" label="Manager" options={managersOptions || []} />,
      type: 'autocomplete',
      label: 'Manager'
    },
    {
      name: 'adAccount',
      value: '',
      filter: (
        <Autocomplete variant="outlined" label="Has AD Account" options={hasAccountsOptions} />
      ),
      type: 'autocomplete',
      label: 'Has AD Account'
    },
    {
      name: 'ldapAccount',
      value: '',
      filter: (
        <Autocomplete variant="outlined" label="Has LDAP Account" options={hasAccountsOptions} />
      ),
      type: 'autocomplete',
      label: 'Has LDAP Account'
    },
    {
      name: 'googleAccount',
      value: '',
      filter: (
        <Autocomplete variant="outlined" label="Has Google Account" options={hasAccountsOptions} />
      ),
      type: 'autocomplete',
      label: 'Has Google Account'
    }
  ]
}
